// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos generales para el Desktop */
.Document {
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
}

/* Título del resultado */
#resultado-titulo {
  font-weight: bold;
  font-size: 1.6rem;
  text-align: center;
  margin: 20px 0;
  color: #333;
}

#info {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

/* From Uiverse.io by ryota1231 */ 
.animated-button {
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 16px 36px;
  border: 4px solid;
  border-color: transparent;
  font-size: 16px;
  border-radius: 100px;
  font-weight: 600;
  color: #223263;
  background-color: transparent;
  box-shadow: 0 0 0 2px transparent;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button svg {
  position: absolute;
  width: 24px;
  fill: #1f387e;
  z-index: 9;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button .arr-1 {
  right: 16px;
}

.animated-button .arr-2 {
  left: -25%;
}

.animated-button .circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button .text {
  position: relative;
  z-index: 1;
  transform: translateX(-12px);
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.animated-button:hover {
  box-shadow: 0 0 0 12px transparent;
  color: #212121;
  border-radius: 12px;
}

.animated-button:hover .arr-1 {
  right: -25%;
}

.animated-button:hover .arr-2 {
  left: 16px;
}

.animated-button:hover .text {
  transform: translateX(12px);
}

.animated-button:hover svg {
  fill: #1f387e;
}

.animated-button:hover .circle {
  width: 220px;
  height: 220px;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ResultadoDocument.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ","sourcesContent":["/* Estilos generales para el Desktop */\n.Document {\n  background-color: #f8f9fa;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n/* Título del resultado */\n#resultado-titulo {\n  font-weight: bold;\n  font-size: 1.6rem;\n  text-align: center;\n  margin: 20px 0;\n  color: #333;\n}\n\n#info {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n/* From Uiverse.io by ryota1231 */ \n.animated-button {\n  text-decoration: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 16px 36px;\n  border: 4px solid;\n  border-color: transparent;\n  font-size: 16px;\n  border-radius: 100px;\n  font-weight: 600;\n  color: #223263;\n  background-color: transparent;\n  box-shadow: 0 0 0 2px transparent;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button svg {\n  position: absolute;\n  width: 24px;\n  fill: #1f387e;\n  z-index: 9;\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button .arr-1 {\n  right: 16px;\n}\n\n.animated-button .arr-2 {\n  left: -25%;\n}\n\n.animated-button .circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  opacity: 0;\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button .text {\n  position: relative;\n  z-index: 1;\n  transform: translateX(-12px);\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.animated-button:hover {\n  box-shadow: 0 0 0 12px transparent;\n  color: #212121;\n  border-radius: 12px;\n}\n\n.animated-button:hover .arr-1 {\n  right: -25%;\n}\n\n.animated-button:hover .arr-2 {\n  left: 16px;\n}\n\n.animated-button:hover .text {\n  transform: translateX(12px);\n}\n\n.animated-button:hover svg {\n  fill: #1f387e;\n}\n\n.animated-button:hover .circle {\n  width: 220px;\n  height: 220px;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
